import { Slide } from "packages/lesson/dist/@types";

import { task as task02 } from "../../../../../task/course-05/lesson-17/task-02";

const task: Slide = {
  title: "The sound reduction index of different building elements is usually:",
  description: "Select the correct answer.",
  layout: {
    type: "simple",
    options: {
      components: {
        variant: "__task__",
        data: {
          id: task02.id,
        },
      },
    },
  },
};

export default task;
